<template>
  <div v-if="contentLabels && contentLabels.length">
      <div
        class="content-item flex articleLabel"
        v-for="(item, index) in contentLabels"
        :key="index"
      >
        <p class="content-item-label">{{ item.name }}</p>
        <div
          class="tab-list"
          v-if="item.contentLabels && item.contentLabels.length"
        >
              <span
                class="check-box"
                :class="{ tabs: label.isChecked }"
                v-for="(label, labelIndex) in item.contentLabels"
                :key="labelIndex"
                @click="$emit('checkArticleLabel', label)"
              >{{ label.name }}</span
              >
        </div>
      </div>
  </div>
</template>

<script>
import {request} from "@/utils/axios";

export default {
  name: "ContentLabel",
  props: ['functionIds'],
  data() {
    return {
      contentLabels:[]
    }
  },
  methods: {
     listTenantContentLabels() {
      return new Promise((resolve,reject) => {
        if (this.contentLabels.length == 0) {
          request(this.functionIds.listTenantContentLabels,{
            tenantId: this.$commonJs.getTenantId()
          }).then(res => {
            this.contentLabels = res.data || [];
            resolve(this.contentLabels);
          }).catch(err => {
            reject(err)
          })
        } else {
          resolve(this.contentLabels)
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.check-box {
	display: inline-block;
	padding: 0 15px;
	height: 32px;
	line-height: 32px;
	cursor: pointer;
	text-align: center;
	// border: 1px solid rgba(216, 220, 229, 1);
	border: 1px solid rgba(216, 220, 229, 1);
	border-radius: 4px;
	margin-right: 30px;
	font-size: 14px;
	// color: rgba(95, 95, 107, 1);
	// color: #0058EE;
	margin-bottom: 10px;
}
// 文字过多，省略样式
.content-item p {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 31px;
}
.checked {
	// background: #0058EE;
	border: 2px solid #0058ee;
	color: #0058ee;
	border-radius: 2px 2px 2px 2px;
}

.tabs {
  border: 1px solid #0058ee !important;
  border-radius: 4px !important;
  color: #0058ee !important;
  background: url("~@/assets/choose.png") right bottom no-repeat;
  background-size: 18px;

  span {
    color: #0058ee !important;
  }

  .have {
    cursor: pointer;
  }

  .button.el-button.el-button--default {
    padding-top: 10px;
  }
}
</style>
